import { pricingPlans } from '../../../mocks/landingData';

const comparisonFeatures = [
  { name: 'Coaching questions', free: '3 per day', pro: 'Unlimited', premium: 'Unlimited' },
  { name: 'Coaching styles', free: '3 styles', pro: 'All 8 styles', premium: 'All 8 styles' },
  { name: 'Daily coaching check-in', free: true, pro: true, premium: true },
  { name: 'Compare Coach Views', free: false, pro: true, premium: true },
  { name: 'Decision Coach', free: false, pro: true, premium: true },
  { name: 'Goal Coach', free: false, pro: true, premium: true },
  { name: 'Procrastination Breaker', free: false, pro: true, premium: true },
  { name: 'Journal history', free: 'Basic', pro: 'Full saved history', premium: 'Full saved history' },
  { name: 'Weekly growth report', free: false, pro: true, premium: true },
  { name: 'Voice coaching', free: false, pro: false, premium: true },
  { name: 'Advanced action plans', free: false, pro: false, premium: true },
  { name: 'Custom coach builder', free: false, pro: false, premium: true },
  { name: 'Export to PDF', free: false, pro: false, premium: true },
  { name: 'Priority new features', free: false, pro: false, premium: true },
];

export default function PricingComparisonTable() {
  const plans = [
    { name: 'Free', price: '$0', period: '7 days' },
    { name: 'Pro', price: '$9.99', period: 'month' },
    { name: 'Premium', price: '$19.99', period: 'month' },
  ];

  return (
    <div className="animate-on-scroll opacity-0 mt-16 md:mt-20">
      <div className="text-center mb-8">
        <h3 className="font-heading text-2xl md:text-3xl font-bold text-warm-white mb-2">
          Compare Plans
        </h3>
        <p className="text-silver-grey text-sm">
          See exactly what you get with each plan
        </p>
      </div>

      <div className="overflow-x-auto rounded-2xl border border-royal-navy/30 bg-midnight/80">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-royal-navy/30">
              <th className="text-left px-4 py-4 md:px-6 md:py-5 text-silver-grey font-medium w-1/3">
                Feature
              </th>
              {plans.map((plan) => (
                <th
                  key={plan.name}
                  className={`px-4 py-4 md:px-6 md:py-5 text-center font-semibold ${
                    plan.name === 'Pro'
                      ? 'text-champagne-gold'
                      : 'text-warm-white'
                  }`}
                >
                  <div className="font-heading text-lg">{plan.name}</div>
                  <div className="text-xs font-normal text-silver-grey mt-1">
                    {plan.price}
                    <span className="text-silver-grey/60">/{plan.period}</span>
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {comparisonFeatures.map((feature, index) => (
              <tr
                key={index}
                className={`border-b border-royal-navy/20 transition-colors hover:bg-royal-navy/10 ${
                  index % 2 === 0 ? 'bg-midnight' : 'bg-midnight/50'
                }`}
              >
                <td className="px-4 py-3 md:px-6 md:py-4 text-warm-white font-medium">
                  {feature.name}
                </td>
                <td className="px-4 py-3 md:px-6 md:py-4 text-center">
                  <CellValue value={feature.free} />
                </td>
                <td className="px-4 py-3 md:px-6 md:py-4 text-center">
                  <CellValue value={feature.pro} highlighted />
                </td>
                <td className="px-4 py-3 md:px-6 md:py-4 text-center">
                  <CellValue value={feature.premium} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function CellValue({
  value,
  highlighted = false,
}: {
  value: boolean | string;
  highlighted?: boolean;
}) {
  if (typeof value === 'boolean') {
    if (value) {
      return (
        <span
          className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${
            highlighted
              ? 'bg-champagne-gold/20 text-champagne-gold'
              : 'bg-green-500/20 text-green-400'
          }`}
        >
          <i className="ri-check-line text-xs" />
        </span>
      );
    }
    return (
      <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-foreground-700/20 text-foreground-600">
        <i className="ri-close-line text-xs" />
      </span>
    );
  }

  return (
    <span
      className={`text-sm ${
        highlighted ? 'text-champagne-gold font-medium' : 'text-silver-grey'
      }`}
    >
      {value}
    </span>
  );
}